window.bssB2BHooks = window.bssB2BHooks || {
  actions: {},
  filters: {},
};

window.BSS_B2B = window.BSS_B2B || {};

window.BSS_B2B.addAction = (tag, callback) => {
  window.bssB2BHooks.actions[tag] = callback;
};
window.BSS_B2B.addFilter = (tag, value) => {
  window.bssB2BHooks.filters[tag] = value;
};

function handle_response_products(curVariantId, { productFormId }) {
  const inputVariant = document.querySelector(`[bss-b2b-product-form-id="${productFormId}"] [id*="product-form-installment-template"] input[name="id"]`);
  if (inputVariant) {
    const variantId = inputVariant.value;
    return Number(variantId);
  }

  return curVariantId;
  
}

window.BSS_B2B.addFilter('detect:product_variant', handle_response_products);


if(window.location.pathname.includes("/products/")) {
    setTimeout(() =>{
      const targetPrice = document.querySelector(".product__info-container .no-js-hidden[bss-b2b-product-id]");
      if (targetPrice) {
        const mutationObserver = new MutationObserver((recordList, observe) => {
          const productForm = document.querySelector("[bss-b2b-product-form]");
          BSS_B2B?.observer?.productSubject?.notifyObserver('VariantChange', 'VariantSelectChange', {productForm});
        });
        mutationObserver.observe(targetPrice, { attributes: true });
      }
    }, 1000)
  }